
import { AppConstants } from "../../../../core/constants/constants";
import InfoNotificationAdmin from "../../domain/entities/InfoNotificationAdmin";
import PaginationNotification from "../../domain/entities/PaginationNotification";
import { NotificationRepository } from "../../domain/repositories/NotificationDataSourceRepository";
import { NotificationDataSource } from "../datasource/NotificationDataSource";

export class NotificationRepositoryImpl implements NotificationRepository {
	constructor(private dataSource: NotificationDataSource) {}
	getNotification(params: PaginationNotification): Promise<InfoNotificationAdmin[]> {
		return AppConstants.getRightOrLeftSide<InfoNotificationAdmin[]>(
			this.dataSource.getNotification(params)
		)
	}
	deleteNotification(notification_id: string): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.deleteNotification(notification_id)
		);
	}
}
